export default __webpack_public_path__ + "static/media/theme-switch-dark.353b7e29.svg";